import React, {memo, useEffect} from "react";
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {
    changeInputsModalEditProfile, ChangeLoaderPostModalEditProfile,
    handelCloseModalEditProfile
} from "../../../../../redux/actions/modals/modalEditProfile";
import axios from "axios";
import {BASE_URL, USERS_EDIT_PROFILE, USERS_PROFILE_GET} from "../../../../../apis";
import qs from "querystring";
import swal from 'sweetalert';
import {actionEditProfileUser, actionLogOutUser} from "../../../../../redux/actions/user/user";

const ModalEditProfile = () => {
    const dispatch = useDispatch();
    const {statusShow, validatedFullName, fullname, email, loaderStatus} = useSelector(state => state.modalEditProfile);
    const {token, profile} = useSelector(state => state.user);
    const {mobile} = profile && profile.mobile ? profile : {mobile: null};

    const changeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(changeInputsModalEditProfile(name, value));
    };

    const handleClose = () => {
        dispatch(handelCloseModalEditProfile());
    };

    const getDataFormEditProfile = async () => {
        try {
            const response = await axios.get(BASE_URL + USERS_PROFILE_GET, {headers: {'Authorization': token}});
            switch (response.data.status) {
                case 'ok':
                    if (response.data.info.fullname !== fullname)
                        dispatch(changeInputsModalEditProfile('fullname', response.data.info.fullname));
                    if (response.data.info.email !== email)
                        dispatch(changeInputsModalEditProfile('email', response.data.info.email));
                    break;
                case "re_login":
                    dispatch(actionLogOutUser());
                    break;
                default:
            }
        } catch (e) {
            console.log(e.response);
        }
    };

    useEffect(() => {
        if (!!token && !fullname && !email)
            getDataFormEditProfile();
    });
    const apiPostEditProfile = () => {
        axios({
            method: 'post',
            url: BASE_URL + USERS_EDIT_PROFILE,
            data: qs.stringify({
                fullname, email,
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    swal({
                        title: "خطا در ویرایش پروفایل",
                        text: response.data.message,
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                    break;
                case 'ok':
                    dispatch(actionEditProfileUser({fullname, email}));
                    swal({
                        title: "ویرایش پروفایل",
                        text: 'ویرایش پروفایل با موفقیت اعمال شد.',
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "success",
                    });
                    handleClose();
                    break;
                case "re_login":
                    break;
                default:
                    swal({
                        title: "خطا در ویرایش پروفایل",
                        text: "لطفا مجددا تلاش کنید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
            }
            dispatch(ChangeLoaderPostModalEditProfile(false));
        }, () => {
            swal({
                title: "خطا در ویرایش پروفایل",
                text: "لطفا مجددا تلاش کنید.",
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
            dispatch(ChangeLoaderPostModalEditProfile(false));
        });
    };

    const handelSendDataFormEditProfile = (event) => {
        dispatch(ChangeLoaderPostModalEditProfile(true));
        event.preventDefault();
        apiPostEditProfile();
    };

    return (
        <React.Fragment>
            <BaseModal title={'ویرایش پروفایل'}
                       show={statusShow}
                       dialogClassName={'modal-login-and-register-custom'}
                       handleClose={handleClose}>
                <Modal.Body>
                    <div>
                        <img src={'https://fruitmruit.com/icons/fm_logo_ofoghi_new.png'} alt={'logo-fruit-mruit'}
                             className={'w-100'}/>
                    </div>
                    <div className={'base-box-forms-login-and-register'}>
                        <Form id={'form-edit-profile'} noValidate onSubmit={handelSendDataFormEditProfile}>
                            <Form.Group>
                                <Form.Control name={'tel'} value={mobile} disabled/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Control type="text"
                                              placeholder="نام و نام خانوادگی"
                                              value={fullname}
                                              required
                                              name={'fullname'}
                                              onChange={changeInputs}
                                              isValid={validatedFullName}
                                              isInvalid={!validatedFullName}
                                />
                                <Form.Control.Feedback type="invalid">
                                    نام کاربری نمیتواند خالی باشد.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group>
                                <Form.Control type="email"
                                              placeholder="ایمیل"
                                              value={email ? email : ''}
                                              name={'email'}
                                              onChange={changeInputs}
                                />
                            </Form.Group>
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type={'submit'} form={'form-edit-profile'} variant="success" className={'base-btn-green'}
                            block onClick={handelSendDataFormEditProfile} disabled={loaderStatus}>
                        <span>تغییر مشخصات</span>
                        {loaderStatus ?
                            <div className={'d-inline-block'}><Spinner className={'mb-1 ml-2'} animation="border"
                                                                       size="sm" variant="danger"/></div> : ''}
                    </Button>
                </Modal.Footer>
            </BaseModal>
        </React.Fragment>
    );
};

export default memo(ModalEditProfile);
